export default __webpack_public_path__ + "static/media/desktop-background-image.a566b3be.jpg";